import { afterEvent, cardRef, createCardInHand, defineGameCard, roundMarkerStatus, } from '../authoring/index.js';
export const JunkDealerCard = defineGameCard({
    id: 'junk_dealer',
    gameplay: {
        type: 'UNIT', cost: 2,
        baseStats: { attack: 1, health: 3 },
    },
    presentation: {
        name: 'Барахольщик',
        description: 'После первой гибели вашего токена в каждом раунде создаёт Запасную деталь в руке.',
        glyph: {
            colors: ['#10213A', '#6B553F', '#AA653C', '#312724', '#E39C64'],
            rows: [
                '....................',
                '....................',
                '.........1..........',
                '.....1..12..13......',
                '.....1.1211.31......',
                '.....2133.13313.....',
                '....111232211111....',
                '...1142221121121....',
                '...4.224442321111...',
                '...114422122122131..',
                '..111111121121.131..',
                '.15514244241142151..',
                '.15534111414434151..',
                '.13555242141211551..',
                '..135551124411551...',
                '...13555532555551...',
                '....135555555311....',
                '....1555555531......',
                '...1555555331.......',
                '..1355555531........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterEvent({
            abilityId: 'token_death_reward',
            event: 'UnitDied',
            frequency: 'first_per_round',
            legacyKey: 'sparePartRound',
            when(ctx, event) {
                const self = ctx.self;
                return self !== undefined && event.isToken === true
                    && event.controllerIdAtDeath === self.controllerId;
            },
            run: createCardInHand(cardRef('spare_part')),
        }),
    ],
    ui: {
        mechanics: ['token', 'death'],
        publicVars: { sparePartRound: { key: 'sparePartRound', kind: 'number' } },
        statusProviders: [roundMarkerStatus({
                fact: 'sparePartRound',
                id: 'junk-dealer-used',
                symbol: '✓',
                label: 'Создание Запасной детали',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=junk-dealer.js.map